import { createContext, useContext } from "react";
export const V5Context = createContext({ ready: true, go: () => {} });
export const useV5 = () => useContext(V5Context);
